/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LineRangeParser = /* #__PURE__ */ parsers.object([
    ['start', codecNumber],
    ['end', codecNumber],
]);
export class LineRange extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LineRangeParser.decode(input).map(res => new LineRange(res));
    }
    static unsafeDecode(input) {
        return LineRange.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LineRangeParser.encode(data);
    }
    static schema() {
        return LineRangeParser.schema();
    }
}
